var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.feedbackComponent,{tag:"component",attrs:{"video-session-id":_vm.videoSessionId,"participant-left-early":_vm.participantLeftEarly,"room":_vm.room},on:{"rematch":function($event){return _vm.$emit('rematch')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }